module.exports = __webpack_public_path__ + "static/media/Pending.bc9f2b95.svg";